export const defaultItemsPerPage = 10;

export const maxAddingNumbers = 50;
export const systemUserLabel = 'system';

export const maxAssignmentNameLength = 255;
